import createConsumer from '../../rest/createConsumer';

const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;

const AuthRestApiConsumer = createConsumer(consumer => {
  const authenticate = ({ username, password }) =>
    new Promise(resolve => {
      consumer
        .putSource(`${AUTH_API_URL}/login`, {
          username,
          password,
        })
        .then(response => {
          if (response.status >= 400) {
            resolve(new Error(response.statusText));
          } else {
            resolve(response.body);
          }
        });
    });

  return Object.freeze({
    authenticate,
  });
});

export default AuthRestApiConsumer;
